module.exports = require('./$.global');


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/$.path.js
// module id = 469
// module chunks = 0 1